// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"fs-z","outfitFeedbackSection":"gs-z"};